import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { StoreDto } from '@/infra/api/generated/model'

type StoreProfileProps = {
  store?: StoreDto
}

const StorePreference = ({ store }: StoreProfileProps) => {
  const { t } = useTranslation('common')
  return (
    <Link
      to="/select-store"
      viewTransition
      className="flex justify-between items-center py-3 hover:bg-gray-50 rounded-md px-2 -mx-2"
    >
      <div>
        <p className="font-medium">{t('components.preferences.store')}</p>
        {store && (
          <p className="text-sm text-gray-500">
            {store.id} - {store.name}
          </p>
        )}
      </div>
      <img alt="right chevron icon" src="/icons/chevron.svg" width={24} height={24} />
    </Link>
  )
}

export default StorePreference
